export class AbstractQueue {
    constructor() {}

    nextItem(perfectTime, imperfectTime): any {
        throw 'not implemented';
    }

    addInterval(interval, status, clear, pad) {
        throw 'not implemented';
    }

    getStartTime(): Cesium.JulianDate {
        throw 'not implemented';
    }

    getStopTime(): Cesium.JulianDate {
        throw 'not implemented';
    }

    isEmpty(): boolean {
        throw 'not implemented';
    }

    clear() {
        throw 'not implemented';
    }

    markAllAsUnfetched() {
        throw 'not implemented';
    }

    getIntervals(data, minSize?, maxSize?): Cesium.TimeIntervalCollection {
        throw 'not implemented';
    }
}
